import { render, staticRenderFns } from "./SavedListDropdown.vue?vue&type=template&id=13f1f871&"
import script from "./SavedListDropdown.vue?vue&type=script&lang=js&"
export * from "./SavedListDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports